import React  from 'react'
import Link from '../../../front/components/shared/sn-link'
import classnames from 'classnames'

import { i18n } from '../../../validator'
import Configurator from '../../../configurator'

@i18n()
class LandingMap extends Configurator {
    render() {
        const { t } = this.props

        return (
            <div className="bg-white pb-5 pt-md-5">
                <div className="d-flex flex-column justify-content-center align-items-center py-4 font-weight-semi-bold landing-world">
                    <h2
                        className={classnames({
                            'font-secondary white-space-pre-wrap font-weight-extra-bold text-center mb-3 mb-md-5 text-color-gray-dark-2': true,
                            'font-size-50': !this.isResponsive(),
                            'font-size-36': this.isResponsive(),
                        })}
                    >
                        {t('landingSectionCTA.title')}
                    </h2>
                    <h2 className="blog d-flex align-items-center font-secondary font-weight-semi-bold mb-5 text-color-grey-dark-2">
                        {t('landingMainBoxHashtag.0')}
                        <table className="text-color-brand d-inline">
                            <tbody>
                                <tr>
                                    <th className="font-weight-semi-bold">
                                        {t('landingMainBoxHashtag.1')}
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                        {t('landingMainBoxHashtag.2')}
                    </h2>

                    {/*@TODO - temporarily hidden */}
                    {false &&
                        <Link
                            className="btn btn-color-brand btn-circle tn-block"
                            to=""
                        >
                            {t('landingSectionCTA.buttonText')}
                        </Link>
                    }
                </div>
            </div>
        )
    }
}

export default LandingMap
